import { render, staticRenderFns } from "./PrivacyProtocolKYFM.vue?vue&type=template&id=19d39944&scoped=true"
import script from "./PrivacyProtocolKYFM.vue?vue&type=script&lang=js"
export * from "./PrivacyProtocolKYFM.vue?vue&type=script&lang=js"
import style0 from "./PrivacyProtocolKYFM.vue?vue&type=style&index=0&id=19d39944&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19d39944",
  null
  
)

export default component.exports